import { createContext, useContext, useState } from 'react';

const translations = {
  da: {
    // Navigation
    dashboard: 'Dashboard',
    conversations: 'Samtaler',
    botConfig: 'Bot Opsætning',
    settings: 'Indstillinger',
    bookings: 'Bookinger',
    
    // Dashboard
    totalConversations: 'Totale Samtaler',
    aiResolutionRate: 'AI Løsningsrate',
    appointmentsBooked: 'Bookede Tider',
    activePlatforms: 'Aktive Platforme',
    conversationsToday: 'Samtaler i dag',
    messagesToday: 'Beskeder i dag',
    recentConversations: 'Seneste Samtaler',
    viewAll: 'Se alle',
    
    // Conversations
    allConversations: 'Alle Samtaler',
    messenger: 'Messenger',
    instagram: 'Instagram',
    active: 'Aktiv',
    resolved: 'Løst',
    pending: 'Afventer',
    noConversations: 'Ingen samtaler endnu',
    selectConversation: 'Vælg en samtale',
    typeMessage: 'Skriv en besked...',
    send: 'Send',
    markResolved: 'Marker som løst',
    
    // Bot Config
    botConfiguration: 'Bot Konfiguration',
    systemPrompt: 'System Prompt',
    systemPromptDesc: 'Definer hvordan AI-botten skal opføre sig og svare',
    model: 'Model',
    enableGeckoBooking: 'Aktiver GECKO Booking',
    enableGeckoBookingDesc: 'Tillad botten at booke tider via GECKO API',
    activePlatformsLabel: 'Aktive Platforme',
    saveChanges: 'Gem Ændringer',
    saving: 'Gemmer...',
    saved: 'Gemt!',
    
    // Bookings
    allBookings: 'Alle Bookinger',
    confirmationCode: 'Bekræftelseskode',
    serviceType: 'Servicetype',
    date: 'Dato',
    time: 'Tid',
    status: 'Status',
    confirmed: 'Bekræftet',
    noBookings: 'Ingen bookinger endnu',
    
    // Common
    search: 'Søg...',
    loading: 'Indlæser...',
    error: 'Fejl',
    success: 'Succes',
    cancel: 'Annuller',
    confirm: 'Bekræft',
    delete: 'Slet',
    edit: 'Rediger',
    
    // Header
    schoolAIBot: 'Chat Bot',
    language: 'Sprog',
  },
  en: {
    // Navigation
    dashboard: 'Dashboard',
    conversations: 'Conversations',
    botConfig: 'Bot Setup',
    settings: 'Settings',
    bookings: 'Bookings',
    
    // Dashboard
    totalConversations: 'Total Conversations',
    aiResolutionRate: 'AI Resolution Rate',
    appointmentsBooked: 'Appointments Booked',
    activePlatforms: 'Active Platforms',
    conversationsToday: 'Conversations Today',
    messagesToday: 'Messages Today',
    recentConversations: 'Recent Conversations',
    viewAll: 'View All',
    
    // Conversations
    allConversations: 'All Conversations',
    messenger: 'Messenger',
    instagram: 'Instagram',
    active: 'Active',
    resolved: 'Resolved',
    pending: 'Pending',
    noConversations: 'No conversations yet',
    selectConversation: 'Select a conversation',
    typeMessage: 'Type a message...',
    send: 'Send',
    markResolved: 'Mark as Resolved',
    
    // Bot Config
    botConfiguration: 'Bot Configuration',
    systemPrompt: 'System Prompt',
    systemPromptDesc: 'Define how the AI bot should behave and respond',
    model: 'Model',
    enableGeckoBooking: 'Enable GECKO Booking',
    enableGeckoBookingDesc: 'Allow the bot to book appointments via GECKO API',
    activePlatformsLabel: 'Active Platforms',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    saved: 'Saved!',
    
    // Bookings
    allBookings: 'All Bookings',
    confirmationCode: 'Confirmation Code',
    serviceType: 'Service Type',
    date: 'Date',
    time: 'Time',
    status: 'Status',
    confirmed: 'Confirmed',
    noBookings: 'No bookings yet',
    
    // Common
    search: 'Search...',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    
    // Header
    schoolAIBot: 'Chat Bot',
    language: 'Language',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('da');
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'da' ? 'en' : 'da');
  };
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
